module.exports = __webpack_public_path__ + "img/IDCard2.d9f0a5af.png";